<template>
  <v-card flat class="pa-2">
    <v-menu
      ref="menu1"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="fechaDesde"
          label="Inicio de Informe"
          persistent-hint
          readonly
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="fecha.desde"
        no-title
        @input="menu1 = false"
      ></v-date-picker>
    </v-menu>
    <v-menu
      ref="menu2"
      v-if="esRango"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="fechaHasta"
          label="Fin de Informe"
          persistent-hint
          readonly
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="fecha.hasta"
        no-title
        @input="menu2 = false"
      ></v-date-picker>
    </v-menu>
    <v-btn
      class="ma-2"
      dark
      block
      color="blue"
      @click="generarInforme()"
      :loading="loadingInforme"
    >
      <v-icon left>mdi-file</v-icon>Generar Informe
    </v-btn>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  name: "SeleccionarFechas",
  props: {
      esRango:{
          type: Boolean,
          default: false
      }
  },
  data: () => ({
    menu1: false,
    menu2: false,
    fecha: {
      desde: new Date().toISOString().substr(0, 10),
      hasta: new Date().toISOString().substr(0, 10),
    },
    textoRangoReporte: '',
    loadingInforme: false
  }),
  methods: {
    async generarInforme() {
      if (this.fecha.desde >= this.fecha.hasta && this.tab === 1) {
        alert("La Fecha de Inicio debe ser anterior a la Fecha de Fin.");
      } else {
        try {
          this.loadingInforme = true;
          let consulta = {
            desde: this.fecha.desde,
            hasta: this.fecha.hasta,
          };
          !this.esRango ? consulta.hasta = consulta.desde : consulta.hasta += " 23:59:59"; 
          let titulo = !this.esRango ? `Reporte diario ${this.$moment(
              consulta.desde
            ).format("dddd DD [de] MMMM YYYY")}`
          :
            `Reporte desde ${this.$moment(
              consulta.desde
            ).format("dddd DD [de] MMMM YYYY")} hasta ${this.$moment(
              consulta.hasta
            ).format("dddd DD [de] MMMM YYYY")}`
          
          consulta.tipo = this.esRango ? "rango" : "diario";
          const informe = await axios.post("/informes", consulta);
          let layout = informe.data
          this.$emit('reporteGenerado', {layout, titulo})
        } catch (error) { console.log(error) }
        this.loadingInforme = false;
      }
    },
  },
  computed: {
    fechaDesde() {
      return this.$moment(this.fecha.desde).format("dddd D [de] MMMM YYYY");
    },
    fechaHasta() {
      return this.$moment(this.fecha.hasta).format("dddd D [de] MMMM YYYY");
    },
  },
};
</script>
